/**
 * Created by lior on 12/1/14.
 */

'use strict';

var _ = require('underscore');
var SoaCollection = require('bunsen/collections/SoaCollection');
var endpoints = require('dibs-endpoints');
var bunsenLib = require('bunsen/libraries/bunsen');
var root = typeof window === 'undefined' ? global : window;
root.bunsen = root.bunsen || {};

/**
 * @class ReferenceSets
 * @extends SoaCollection
 */
root.bunsen.ReferenceSets = module.exports = SoaCollection.extend({
    url: endpoints.referenceSet(),
    parse: function (data) {
        return data && data.reference_set && data.reference_set.row ? data.reference_set.row : null;
    },
    /**
     * @param {string[]} types
     * @param {object} options Backbone fetch options
     * @returns {Deferred.promise}
     */
    fetchByType: function (types, options) {
        var oldUrl = this.url;
        var prom;
        this.url = _.result(this, 'url') + '?' + bunsenLib.queryStringFromObj({ type: types }, true);
        prom = this.fetch(options);
        this.url = oldUrl;
        return prom;
    }
});


//////////////////
// WEBPACK FOOTER
// ./~/bunsen/collections/queryservice/ReferenceSets.js
// module id = 2626
// module chunks = 64